import React from 'react';

const Footer = () => {

    return (
        <div className="footer">
            <ul className="nav nav-tabs">
                <li className='footer-links'>
                    <a className='navStyle' href="https://github.com/syackzan" target="_blank" rel="noreferrer">Github</a>
                </li>
                <li className='footer-links'>
                    <a className='navStyle' href="https://www.linkedin.com/in/scotty-yackzan-1427b335" target="_blank" rel="noreferrer">LinkedIn</a>
                </li>
            </ul>
        </div>
    )
}

export default Footer;